import { MenuEntry } from '@luthebao/uikit'
import { ContextApi } from 'contexts/Localization/types'

const bscConfig: (t: ContextApi['t']) => MenuEntry[] = (t) => []

export default bscConfig
